import httpClient from '../httpClient';

const createQuestionValidation = async (data) => {
  return await httpClient.post(`question_validation/`, data);
};

const updateQuestionValidation = async (id, data) => {
  return await httpClient.put(`question_validation/${id}/`, data);
};

const deleteQuestionValidation = async (id) => {
  return await httpClient.delete(`question_validation/${id}/`);
};

const queryQuestionValidation = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/question_validation/?page[number]=${page}&page[size]=${pageSize}${sortBy}${searchBy}`,
    { params: query },
  );
};

export {
  createQuestionValidation,
  updateQuestionValidation,
  deleteQuestionValidation,
  queryQuestionValidation,
}
